import { ComponentType } from '@angular/cdk/portal';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppError } from 'src/app/core/errors/http-error/app-error';
import { BuildingClassificationLayerService } from 'src/app/layers/service/building-classification-layer.service';
import { DialogService } from 'src/app/shared/components/dialog/dialog.service';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { ProjectDemographicAreasService } from '../../layers/service/project-demographic-areas.service';
import { SimulationFormComponent } from '../simulation-form/simulation-form.component';
import { Simulation } from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';
import { SimulationStore } from '../state/simulation.store';

@Component({
  selector: 'app-simulation-header',
  templateUrl: './simulation-header.component.html',
  styleUrls: ['./simulation-header.component.scss']
})
export class SimulationHeaderComponent implements OnInit, OnDestroy {

  simulation$ = this.simulationQuery.active$;
  isLoading: boolean;
  error: AppError;

  constructor(
    private simulationService: SimulationService,
    private simulationQuery: SimulationQuery,
    private windowService: WindowService,
    private dialogService: DialogService,
    private simulationStore: SimulationStore,
    private projectDemographicAreasService: ProjectDemographicAreasService,
    private buildingClassificationLayerService: BuildingClassificationLayerService
  ) { }

  ngOnInit(): void {
    this.buildingClassificationLayerService.load();
  }

  ngOnDestroy(): void {
  }

  back() {
    const shouldReloadDemographicAreas = this.simulationStore.getValue().resultMode;
    this.simulationService.desactive();
    if (shouldReloadDemographicAreas) {
      this.projectDemographicAreasService.load();
    }
  }

  config() {
    this.open($localize`EDIT NETWORK`, SimulationFormComponent, this.simulationQuery.getActive());
  }


  remove() {
    const title = $localize`Do you really want to remove?`;
    this.dialogService.confirm(title)
      .subscribe(result => {
        if (result) {
          this.isLoading = true;
          this.simulationService.remove(this.simulationQuery.getActiveId())
            .pipe(
              catchError((error) => {
                this.error = error;
                return throwError(error);
              })
            )
            .subscribe(() => this.isLoading = false);
        }
      });

  }

  private open(title: string, componentType: ComponentType<any>, data: Simulation) {
    this.windowService.open({ title, componentType, config: { data } });
  }
}
